#import "../fragments/potential-activity-entity-fragment.graphql"

query GetPotentialActivityEntities($input: PotentialEntitiesInput!) {
    activityPotentialEntities(input: $input) {
        relatedEntities {
            ...PotentialActivityEntityFragment
        }
        participants {
            ...PotentialActivityEntityFragment
        }
    }
}
